export default __webpack_public_path__ + "static/media/logo2.7f6a53d1.svg";